<div class="wrapper mt-5 ">
    <div class="section-dark mt-5 "
        style="background-image: url('./assets/img/website_2/image_8.png'); background-position: center; background-size: cover;">
        <div class="content-center">
            <div class="container mt-5 text-center text-vertical-center">

                <h1 class="pt-5 mt-5 font-weight-bold" style="height: 250px; color: #184685;">e-Buro</h1>


            </div>
        </div>

    </div>
</div>

<div class="container mt-n1 justify-content-center"
    style="z-index: 900; position: absolute; left: 50%; transform: translateX(-50%);">
    <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


        <div class="col-lg-8 mt-lg-n2 mt-2">
            <label class="">&nbsp;</label>
            <button type="button" class="btn btn-sm bg-gradient-secondary w-100 mb-0"><i class="fa fa-angle-down"
                    aria-hidden="true"></i> A Complete END-TO-END Solution for Healthcare Professionals <i
                    class="fa fa-angle-down" aria-hidden="true"></i></button>
        </div>
    </div>
</div>

<div class="container z-5 ">
    <!-- <a type="button" class="float d-none d-lg-block">
    <i class="fa fa-angle-down" aria-hidden="true"></i> Scroll down for more info <i class="fa fa-angle-down"
      aria-hidden="true"></i>
  </a> -->

</div>




<div class="features-66">
    <div class="container  ml-auto mr-auto">
        <div class="row ml-auto mr-auto">
            <div class="col-lg-12 mt-lg-n2 mt-2 ml-auto mr-auto text-center">
                <h3 class="title  font-weight-bold">Managing a Healthcare Practice Is Hard Work</h3>


                <p class="ml-auto mr-auto text-center"> Especially when you’re...
                </p><br>

                <li class="font-weight-bold text-center">Wasting time on manual admin,</li>
                <li class="font-weight-bold text-center">Losing revenue from billing errors, and</li>
                <li class="font-weight-bold text-center">Frustrating staff and patients.</li>

                <br>
                <p class="text-center">
                    You're left feeling overwhelmed and stuck starting chaos instead of leading care.
                    That’s why eMD’s practice management software simplifies it all, giving you back control, clarity,
                    and most importantly; more time to focus on what matters most: your patients.
                </p>


            </div>
        </div>
    </div>
</div>





<!--     *********     FEATURES 3      *********      -->
<div class="features-3 section-gray" id="ref_cn">
    <div class="container section-gray">
        <div class="row">


            <div class="col-md-12">
                <h3 class="title text-center font-weight-bold">Manage Your Practice Efficiently with e-Buro, <br>
                    Focus on Patient Care
                </h3>
                <div class="row">


                    <div class="col-md-7">
                        <div class="row">
                            <div class="container">

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="info-horizontal">

                                    <div class="description  font-weight-bold">

                                        All our packages includes the
                                        following functionality and features:


                                    </div>
                                </div>
                                <div class="info-horizontal col-md-12">
                                    <div class="description col-md-12 ">

                                        <div class="row col-md-12">
                                            <div class="col-md-6">
                                                <ul class="info text-left">
                                                    <li>e-AI: AI-powered precision for diagnosis and treatment decisions
                                                    </li>
                                                    <li>Benefit Check</li>
                                                    <li>Bulk SMS</li>
                                                    <li>Calendar Appointments</li>
                                                    <li>Clinical Notes </li>
                                                    <li>Cloud Application </li>
                                                    <li>Comprehensive Clinical Notes</li>
                                                    <li>Electronic Data Interchange (EDI)</li>
                                                    <li>Electronic Medical Records</li>
                                                    <li>Electronic Patient File Management</li>
                                                    <li>Electronic Remittance Advice</li>
                                                    <li>Electronic Switching </li>
                                                    <li>eScript: Electronic Prescriptions</li>
                                                    <li>Free Rates Updates</li>
                                                    <li>Graphically Represented Clinical Results</li>
                                                    <li>Healthcare Advisory </li>
                                                    <li>Healthcare IT Consulting </li>


                                                </ul>
                                            </div>
                                            <div class="col-md-6">


                                                <ul class="info text-left">

                                                    <li>Medical Billing</li>
                                                    <li>Medical Debt Management </li>
                                                    <li>Member Validation</li>
                                                    <li>Mobile Web App</li>
                                                    <li>Paediatric Graphs </li>
                                                    <li>Paperless Solution </li>
                                                    <li>Pathology Results </li>
                                                    <li>Patient Clinical Records</li>
                                                    <li>Patient Debt Recovery </li>
                                                    <li>Patient Family Check</li>
                                                    <li>Practice Management Application</li>
                                                    <li>Real-time Benefit Checks</li>
                                                    <li>Real-time Claims</li>
                                                    <li>Real-Time Claims Submission</li>
                                                    <li>Real-time Pathology Results Graphed</li>
                                                    <li>Tariff Coding and Pricing</li>
                                                    <li>Training Services </li>
                                                    <li>Virtual Consultations</li>
                                                </ul>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>




                        </div>
                    </div>
                    <div class="col-md-5 ml-auto mr-auto text-center">
                        <div class="row mb-2">

                            <div class="col-md-12 ml-auto mr-auto text-center">

                                <div class="img img-container">
                                    <img src="./assets/img/website_2/image_5.png" />
                                </div>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-md-10 ml-auto mr-auto text-center">

                                <button type="button" class="btn btn-sm btn-danger mb-3"
                                    [routerLink]="['/get-a-quote/e-buro']">e-Buro Quote</button>
                                <p>Ideal for Healthcare Providers who want
                                    comprehensive Bureau services.</p>
                                <h3 class="card-category text-left"><strong></strong>eMD</h3>

                                <div class="description text-left ms-2">

                                    <i class="fa fa-check" aria-hidden="true"></i>Patient file and claim
                                    capturing.<br>
                                    <i class="fa fa-check" aria-hidden="true"></i>Billing and submission of
                                    claims.<br>
                                    <i class="fa fa-check" aria-hidden="true"></i>Medical aids follow-ups.<br>
                                    <i class="fa fa-check" aria-hidden="true"></i>Claims and Medical Aid Debt
                                    reconciliation.


                                </div>
                            </div>
                        </div>


                    </div>


                </div>
            </div>
        </div>
    </div>
</div>


<div class="container mt-n1 justify-content-center"
    style="z-index: 900; position: absolute; left: 50%; transform: translateX(-50%);">
    <div class="row mt-n5 pb-4 p-3 mx-sm-0 mx-1 position-relative justify-content-center">


        <div class="col-lg-8 mt-lg-n2 mt-2">
            <label class="">&nbsp;</label>
            <button type="button" class="btn btn-sm btn-danger w-100 mb-0" [routerLink]="['/get-a-quote/e-buro']"> Get A
                Quote </button>
        </div>
    </div>
</div>

<app-block-info></app-block-info>


<app-packages></app-packages>